import type { CapabilityToken, IRoleCapability } from '@platform/shared/lib/roles/types';
import { RoleAccessMapping, RoleAccessType } from '@platform/entities/sys/role-access-type.enum';
import { UserStore } from '@platform/store';
import config from '@platform/shared/config';

type RoleAccessKey = 'can_access' | 'can_modify' | 'can_create' | 'can_delete';

function checkRoleCapability(
    capability: IRoleCapability | CapabilityToken | null,
    needs: Array<RoleAccessKey> | RoleAccessKey = 'can_access',
    shouldBeAtLeast: RoleAccessType = RoleAccessType.Own,
    anyOfMode = false
) {
    let cap: IRoleCapability | null = null;
    const godMode = (config.roles.superadminCanDoAnything && UserStore.userState.user?.role?.is_superadmin) || false;
    if (typeof capability === 'string') {
        cap = UserStore.userState.user?.role.capabilities?.get(capability) ?? null;
        if (!cap) return godMode;
    } else {
        cap = capability;
    }
    if (!cap) return true;
    if (cap.is_superadmin_related) {
        if (!UserStore.userState.user?.role?.is_superadmin) {
            return false;
        }
    }
    if (godMode) return true;
    if (cap.is_single_choice) return cap.is_single_choice_granted ?? false;
    const needsList = Array.isArray(needs) ? needs : [needs];
    return needsList[anyOfMode ? 'some' : 'every'](
        (need) => RoleAccessMapping[cap?.[need] ?? RoleAccessType.Restrict] >= RoleAccessMapping[shouldBeAtLeast]
    );
}
checkRoleCapability.anyOf = function (
    capability: IRoleCapability | CapabilityToken | null,
    needs: Array<RoleAccessKey> | RoleAccessKey,
    shouldBeAtLeast: RoleAccessType = RoleAccessType.Own
) {
    return checkRoleCapability(capability, needs, shouldBeAtLeast, true);
};

export { checkRoleCapability };
